module.exports = __webpack_public_path__ + "static/media/Signet-Ring_thumb.2c8cf150.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/jewellery/Signet-Ring_thumb.png
// module id = 246
// module chunks = 0